import { useState } from "react"
import { Accordion } from "../components/Accordion"
import { CheckoutCardForm } from "../components/CheckoutCardForm"
import ContentSection from "../components/ContentSection"
import { DebugToolCardPaymentSnippet } from "../components/debug/DebugToolCardPaymentSnippet"
import { DebugToolCreatedCardSnippet } from "../components/debug/DebugToolCreatedCardSnippet"
import { DebugToolCustomerSnippet } from "../components/debug/DebugToolCustomerSnippet"
import DebugToolModalButton from "../components/debug/DebugToolModalButton"
import { DebugToolOneTimePaymentSnippet } from "../components/debug/DebugToolOneTimePaymentSnippet"
import { DebugToolPaymentTokenSnippet } from "../components/debug/DebugToolPaymentTokenSnippet"
import { DropdownMenu } from "../components/DropdownMenu"
import Footer from "../components/Footer"
import HomeButton from "../components/HomeButton"
import LandingButton from "../components/LandingButton"
import NavBar from "../components/NavBar"
import PayWithNewCardForm from "../components/PayWithNewCardForm"
import TitleSection from "../components/TitleSection"
import UserCard from "../components/UserCard"
import VaultedCardsButton from "../components/VaultedCardsButton"

export function CheckoutPage() {
    const [isVaultedCardPayment, setIsVaultedCardPayment] = useState(true)
    const [saveCard, setSaveCard] = useState(false)
    
    return (
        <div className="body">
        <NavBar 
            left={
                <>
                  <HomeButton />
                  <DropdownMenu>
                    <LandingButton/>
                    <VaultedCardsButton/>
                  </DropdownMenu>
                </>
            }
            right={<UserCard/>}
        />
        <TitleSection text="Pay Using"/>
        <ContentSection>
            <Accordion header="Saved Cards" group="checkout" index="1" type="radio" checked={isVaultedCardPayment} onChange={() => setIsVaultedCardPayment(true)}>
                <CheckoutCardForm/>
            </Accordion>
            <Accordion header="Use A Different Card" group="checkout" index="2" type="radio" checked={!isVaultedCardPayment} onChange={() => setIsVaultedCardPayment(false)}>
               <PayWithNewCardForm saveCard={saveCard} setSaveCard={() => setSaveCard(!saveCard)} />
            </Accordion>
        </ContentSection>
        <Footer>
            <DebugToolModalButton header='Debug Tool'>
                {isVaultedCardPayment ? <VaultedCardPaymentSnippet /> : <NewCardPaymentSnippet saveCard={saveCard} />}
            </DebugToolModalButton>
        </Footer>
        </div>
    )
}

function VaultedCardPaymentSnippet() {
    return (
        <Accordion header='Card Payment Payload' index='3' group='debug' type="checkbox" defaultChecked={true}>
            <DebugToolCardPaymentSnippet/>
        </Accordion>
    )
}

interface NewCardPaymentSnippetProps {
    saveCard: boolean
}
function NewCardPaymentSnippet({ saveCard }: NewCardPaymentSnippetProps) {
    return (
        <>
            <Accordion header='Create Payment Token Payload' index='4' group='debug' type='checkbox' defaultChecked={true}>
                <DebugToolPaymentTokenSnippet />
            </Accordion>
            
            {saveCard ? 
                <>
                    <Accordion header='Create Customer Payload (if no customer created yet)' index='5' group='debug' type='checkbox' defaultChecked={true}>
                        <DebugToolCustomerSnippet/>
                    </Accordion>
                    <Accordion header='Create Card Payload' index='6' group='debug' type='checkbox' defaultChecked={true}>
                        <DebugToolCreatedCardSnippet />
                    </Accordion>
                    <Accordion header='Vaulted Card Payment Payload' index='7' group='debug' type="checkbox" defaultChecked={true}>
                        <DebugToolCardPaymentSnippet/>
                    </Accordion>
                </> :
                <Accordion header='One Time Payment Payload' index='8' group='debug' type="checkbox" defaultChecked={true}>
                    <DebugToolOneTimePaymentSnippet />
                </Accordion>
            }
        </>
    )
}